export { default as Header } from 'reports/components/disabled/DisabledReportHeader';
export { default as Table } from 'reports/components/disabled/DisabledReportTable';
export { default as Filters } from 'reports/components/disabled/DisabledReportFilters';



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/disabled/index.js